import React, {useCallback, useContext, useEffect} from "react";
import {createUseStyles} from "react-jss";
import {Theme} from "engage-client/theme";
import ChatInput from "./ChatInput";
import ChatHistory from "./ChatHistory";
import {EngageAppContext} from "../../App";
import clsx from "clsx";
import {TriviaAction} from "../../messages/messages";
import {ChatContext, ChatUIState} from "../../contexts/ChatContext";

const useStyles = createUseStyles<Theme>((theme) => ({
    chat: {
        position:"relative",
        padding: [0,8,8,8]
    },
    fixed: {
        flex:1,
        display: "flex",
        flexDirection: "column"
    },
    popup: {
        transition: "background 250ms ease-in-out",
        background: ({chatUIState:cs}) => cs === ChatUIState.none ? "transparent" : cs === ChatUIState.focused ? theme.chat.background.focused : theme.chat.background.unfocused,
        zIndex: 10
    }
}));

type ChatProps = {
    className?: string
    popup?: boolean
}

const Chat = ({popup = false, className}:ChatProps) => {
    const {appState, sendMessage} = useContext(EngageAppContext.current);
    const {chatReadCount, setChatReadCount, setChatUIState, chatUIState} = useContext(ChatContext);
    const classes = useStyles({chatUIState});

    const setUIState = useCallback((newState:ChatUIState) => {
        if(popup) {
            setChatUIState(newState);
        }
    }, [popup, setChatUIState]);

    useEffect(() => {
        setChatUIState(current => popup ? current : ChatUIState.focused);
        return () => {
            if(!popup) {
                setChatUIState(ChatUIState.none);
            }
        };
    },[setChatUIState, popup]);

    useEffect(() => {
        if(chatUIState === ChatUIState.focused) {
            if(chatReadCount !== appState.chat.entries.length) {
                setChatReadCount(appState.chat.entries.length);
                sendMessage({
                    type: TriviaAction.ReadChat,
                    count: appState.chat.entries.length
                });
            }
        }
    }, [appState.chat.entries, chatUIState, setUIState, popup, sendMessage, chatReadCount, setChatReadCount]);

    return (
        <div className={clsx(classes.chat, !popup && classes.fixed, popup && classes.popup, className)}>
            <ChatHistory chatUIState={chatUIState} popup={popup}/>
            <ChatInput setChatUIState={setUIState} shouldFocus={!popup}/>
        </div>
    );
};

export default Chat;